import { render, staticRenderFns } from "./InformationDisplay.vue?vue&type=template&id=0b93634e"
import script from "./InformationDisplay.vue?vue&type=script&lang=js"
export * from "./InformationDisplay.vue?vue&type=script&lang=js"
import style0 from "./InformationDisplay.vue?vue&type=style&index=0&id=0b93634e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports